/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ellipsis-item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import Button from '@atlaskit/button/standard-button';
import __noop from '@atlaskit/ds-lib/noop';
var noop = __noop;
var itemWrapperStyles = null;
var staticItemStyles = null;
var EllipsisItem = /*#__PURE__*/memo(function (_ref) {
  var label = _ref.label,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("li", {
    className: ax(["_1e0c1txw _vchhusvi _p12f1osq _4t3i59ms _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"]),
    style: {
      "--_1fdrbou": ix("".concat(24 / 14, "em"))
    }
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle-link",
    "aria-label": label,
    onClick: onClick,
    spacing: "none",
    testId: testId,
    className: ax(["_1rjc1raa _k48p13dq _vwz41txs"]),
    style: {
      "--_ymfj9u": ix("var(--ds-font-weight-regular, 400)".concat(" !important")),
      "--_lugd7d": ix("var(--ds-space-025, 2px)".concat(" !important"))
    }
  }, "\u2026"));
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default EllipsisItem;